function useRows({
  rows,
  pinnedRow,
  rowsPerPageOptions,
  rawModels,
  pinnedRawModel
}) {
  function addRawModelToRow(row, rawModel) {
    if (Object.isExtensible(row)) {
      const r = row;
      r.__rawModel = rawModel;
      return r;
    }
    return { ...row, __rawModel: rawModel };
  }
  const rowsWithRawModels = rows?.map((r, index) => addRawModelToRow(r, rawModels[index])) ?? [];
  const rowWithPinned = pinnedRow ? [addRawModelToRow(pinnedRow, pinnedRawModel), ...rowsWithRawModels] : rowsWithRawModels;
  return {
    rows: rowWithPinned,
    rowsPerPageOptions: rowsPerPageOptions ?? (pinnedRow ? [10, 25, 50, 99] : [10, 25, 50, 100])
  };
}
export {
  useRows
};
//# sourceMappingURL=useRows.js.map
